import React from 'react';

export default class Button extends React.Component {
    render() {
        const {clickHandler, text} = this.props;
        const className = "btn " + ( this.props.className ? this.props.className : "btn-default" );
        return <button className={className} onClick={clickHandler} >{text}</button>
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Forms/Button.js